import { graphql, useStaticQuery } from 'gatsby';
import { FeatureCards as SharedFeatureCards } from '../FeatureCards';
import { transformTextFeatureCards } from '../FeatureCards/utils';

function FeatureCards() {
    const { featureCards } = useStaticQuery(graphql`
        {
            featureCards: contentfulSiteTextContent(name: { eq: "Home Feature Cards" }) {
                contentLocation {
                    title
                    descriptionRich {
                        raw
                    }
                    description {
                        description
                    }
                    buttonText
                    buttonColor
                    cta
                    icon {
                        gatsbyImageData
                        localFile {
                            publicURL
                            extension
                        }
                    }
                }
            }
        }
    `);

    const cards = transformTextFeatureCards(featureCards);

    return <SharedFeatureCards cards={cards} gridClassName='gap-8' />;
}
export default FeatureCards;
